import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';

const PLANNER_ITEMS = [
  { id: 'todo', label: 'To-Do Hub' },
  { id: 'calendar', label: 'Calendar' },
  { id: 'contacts', label: 'Contacts' },
];

export default function PlannerSidebar({ isOpen, onClose }) {
  const location = useLocation();
  const selectedId = location.pathname.split('/')[2] || null;

  return (
    <div className={`projects-slideout ${isOpen ? 'open' : ''}`}>
      {/* HEADER — identical to Projects */}
      <div className="projects-header">
        <h3>Planner</h3>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
      </div>

      {/* SEARCH — identical to Projects */}
      <div className="projects-search-container">
        <div className="projects-search-wrapper">
          <input
            type="text"
            placeholder="Search Planner…"
            disabled // planner doesn't need live search yet
          />
          <MagnifyingGlassIcon className="projects-search-icon" />
        </div>
      </div>

      {/* LIST — styled like Projects list */}
      <ul className="projects-list">
        {PLANNER_ITEMS.map((item) => (
          <li key={item.id} className={`project-item ${selectedId === item.id ? 'selected' : ''}`}>
            <Link to={`/planner/${item.id}`} className="project-link" onClick={onClose}>
              {item.label}
            </Link>
          </li>
        ))}

        {PLANNER_ITEMS.length === 0 && <li className="no-projects">No planner sections found.</li>}
      </ul>
    </div>
  );
}
